import { PortalHomeQuery, usePortalPolicyAcknowledgeMutation } from "@dashboard/graphql";
import { Box, Button, Text } from "@saleor/macaw-ui-next";
import { useIntl } from "react-intl";

import { ErrorText, Page, Section } from "./components";
import { portalMessages as m } from "./messages";

/**
 * First sign-in (and after each new version): the privacy notice and the
 * internal regulation must be acknowledged before anything else; optional
 * consents may be refused.
 */
export const PolicyGate = ({
  documents,
  onDone,
}: {
  documents: PortalHomeQuery["pendingPolicies"];
  onDone: () => void;
}) => {
  const intl = useIntl();
  const [acknowledge, opts] = usePortalPolicyAcknowledgeMutation({
    onCompleted: data => {
      if (!data.policyAcknowledge?.errors.length) {
        onDone();
      }
    },
  });
  const doc = documents[0];

  return (
    <Page>
      <Text size={8} fontWeight="bold">
        {intl.formatMessage(m.policiesTitle)}
      </Text>
      <Text size={3} color="default2">
        {intl.formatMessage(m.policiesIntro)}
      </Text>
      <Section title={`${doc.title} (v${doc.version})`}>
        <Box
          __maxHeight="55vh"
          overflowY="auto"
          padding={3}
          borderWidth={1}
          borderStyle="solid"
          borderColor="default1"
          borderRadius={3}
        >
          <Text size={3} __whiteSpace="pre-wrap">
            {doc.body}
          </Text>
        </Box>
        {!doc.isMandatory && (
          <Text size={2} color="default2">
            {intl.formatMessage(m.optionalConsent)}
          </Text>
        )}
        <Box display="flex" gap={2} flexWrap="wrap">
          <Button
            variant="primary"
            disabled={opts.loading}
            onClick={() => acknowledge({ variables: { id: doc.id, accepted: true } })}
          >
            {intl.formatMessage(doc.isMandatory ? m.acknowledge : m.consentAccept)}
          </Button>
          {!doc.isMandatory && (
            <Button
              variant="secondary"
              disabled={opts.loading}
              onClick={() => acknowledge({ variables: { id: doc.id, accepted: false } })}
            >
              {intl.formatMessage(m.consentRefuse)}
            </Button>
          )}
        </Box>
        <ErrorText errors={opts.data?.policyAcknowledge?.errors} />
      </Section>
    </Page>
  );
};
